import { getWindowScrollTop } from 'ava-util/dist/dom-window';
import { hasClass } from 'ava-util/dist/dom-class';

export type IScrollToAnchorConfig = {
    scrollWrap?: Element,
    selector: string | HTMLElement,
    offset?: number,
    behavior?: ScrollBehavior | 'instant',
    minusHeader?: boolean; //是否减去页头高度，从上往下跳，且模块 paddingTop 足够大时设为 false
    from?: 'modal' | 'drawer' | 'default';
}

export const scrollToAnchor = (config: IScrollToAnchorConfig) => {
    const {
        scrollWrap,
        selector,
        offset = 0,
        behavior,
        minusHeader = true,
        from = 'default',
    } = config

    if (selector) {
        const target = typeof selector === 'string' ? document.querySelector(selector) : selector;

        if (target) {
            const rectTop = target.getBoundingClientRect().top;

            if (scrollWrap) {
                let scrollTop = scrollWrap.scrollTop || 0;

                const wrapRectTop = scrollWrap ? scrollWrap.getBoundingClientRect().top : 0;
                const wrapDist = scrollTop + rectTop - wrapRectTop - offset;

                scrollWrap.scrollTo({
                    top: wrapDist,
                    behavior: behavior as ScrollBehavior || "smooth"
                });
            } else if (from === 'modal') {
                const wrap = target.closest('.ant-modal-wrap') as HTMLDivElement;
                const body = wrap?.children[0];
                if (!body) {
                    return;
                }
                wrap.scrollTo({
                    top: target.getBoundingClientRect().top - body.getBoundingClientRect().top,
                    behavior: behavior as ScrollBehavior || "smooth"
                });
            } else if (from === 'drawer') {
                const drawer = target.closest('.sw-drawer') as HTMLDivElement;
                if (!drawer) {
                    return;
                }
                let wrap: HTMLDivElement = drawer.querySelector('.sw-drawer-wrapper') as HTMLDivElement;
                let body = drawer.querySelector('.sw-drawer-body') as HTMLDivElement;

                if (hasClass(drawer, 'sw-drawer-left') || hasClass(drawer, 'sw-drawer-right')) {
                    wrap = body;
                    body = body.children[0] as HTMLDivElement;
                    if(body) {
                        wrap.scrollTo({
                            top: target.getBoundingClientRect().top - body.getBoundingClientRect().top,
                            behavior: behavior as ScrollBehavior || "smooth"
                        });
                    }
                } else {
                    wrap.scrollTo({
                        top: target.getBoundingClientRect().top - body.getBoundingClientRect().top,
                        behavior: behavior as ScrollBehavior || "smooth"
                    });
                }
            } else {
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                let fixedHeaderHeight = 0;
                if (minusHeader) {
                    const fixedHeader = document.getElementById('js-sticky-header');
                    if (fixedHeader) {
                        fixedHeaderHeight = fixedHeader.offsetHeight;
                    }
                }
                window.scrollTo({
                    top: scrollTop + rectTop - offset - fixedHeaderHeight,
                    behavior: behavior as ScrollBehavior || "smooth"
                });
            }
        }
    }
}

export const scrollToTop = () => scrollToAnchor({ selector: '#__next' });

export const asyncScrollToAnchor = (selector: string, offset: number = 0, behavior?: ScrollBehavior | 'instant'): Promise<void> => {
    return new Promise((resolve) => {
        if (!selector) {
            resolve();
        }
        const target = document.querySelector(selector);
        if (!target) {
            resolve();
        }
        const scrollTop = getWindowScrollTop();
        const rectTop = (target as HTMLElement).getBoundingClientRect().top;
        let fixedHeaderHeight = 0;
        const fixedHeader = document.getElementById('js-sticky-header');
        if (fixedHeader) {
            fixedHeaderHeight = fixedHeader.offsetHeight;
        }
        const endTop = scrollTop + rectTop - offset - fixedHeaderHeight;
        if (scrollTop === endTop) {
            resolve();
        }

        const listener = () => {
            if (getWindowScrollTop() === endTop) {
                window.removeEventListener('scroll', listener);
                resolve();
            }
        };

        window.addEventListener('scroll', listener);
        window.scrollTo({
            top: endTop,
            behavior: behavior as ScrollBehavior || 'smooth'
        });
    });
}

export const asyncScrollToTop = () => asyncScrollToAnchor('#__next');


/**
 * 判断元素是否在滚动区域内的可视范围中
 * @param el
 * @param scrollArea
 */
export const isElementInScrollArea = (el: Element, scrollArea: Element) => {
    const elRect = el.getBoundingClientRect();
    const scrollAreaRect = scrollArea.getBoundingClientRect();
    // 检查元素是否在滚动区域的可见范围内
    const isInVerticalView = (
        elRect.top >= scrollAreaRect.top &&
        elRect.bottom <= scrollAreaRect.bottom
    );
    const isInHorizontalView = (
        elRect.left >= scrollAreaRect.left &&
        elRect.right <= scrollAreaRect.right
    );
    return isInVerticalView && isInHorizontalView;
}

/**
 * 元素滚动至滚动区域offset的位置
 * @param params
 */
export const scrollToElementWithOffset = (params: {
    container: Element;
    element: Element;
    offset?: number;
    behavior?: 'instant' | 'smooth';
}) => {
    const { container, element, offset = 0, behavior = 'instant' } = params;

    const containerRect = container?.getBoundingClientRect();
    const elRect = element.getBoundingClientRect();
    const elTopRelativeToContainer = elRect.top - containerRect.top;
    const targetScrollTop = container.scrollTop + elTopRelativeToContainer - offset;

    container.scrollTo({ top: targetScrollTop, behavior: behavior });
}